import Head from 'next/head';
import PlpPage from '../../../components/mui5/plp';
export default function Product() {
  return <PlpPage />;
}
// export async function getStaticProps(context) {
//   return {
//     props: {
//       extraMeta: {
//         title: HeadTitleContent['product'].title,
//         description: HeadTitleContent['product'].description,
//         schemaData: 'product',
//       },
//     },
//   };
// }
